export function formatCitationText(input) {
  let html = String(input || '');

  html = html.replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, '');
  html = html.replace(/\son\w+\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi, '');
  html = html.replace(/javascript:/gi, '');

  html = html.replace(/<br\s*\/?>/gi, ' ');
  html = html.replace(/[\r\n\t]+/g, ' ');
  html = html.replace(/\s{2,}/g, ' ');

  html = html.replace(/&lt;(https?:\/\/[^\s&]+)&gt;/gi, '$1');
  html = html.replace(/<(https?:\/\/[^\s>]+)>/gi, '$1');

  const parts = html.split(/(<[^>]+>)/g);

  const linked = parts
    .map((part) => {
      if (!part || part.startsWith('<')) return part;

      return part.replace(/(https?:\/\/[^\s<]+)/g, (rawUrl) => {
        let url = rawUrl;
        let trailing = '';

        while (/[\]\)\}\.,;:!?]$/.test(url)) {
          trailing = url.slice(-1) + trailing;
          url = url.slice(0, -1);
        }

        const safeHref = url.replace(/"/g, '%22');

        return (
          `<a href="${safeHref}" target="_blank" rel="noreferrer" class="text-blue-600 hover:underline break-all">${url}</a>` +
          trailing
        );
      });
    })
    .join('');

  return linked;
}